import { checkPointDocumentsMap } from '../../constants/mddap-checkpoint-document-types';
import Joi from 'joi';

const CheckpointDocumentsValidator = {
  validateCheckpointDocuments: (documents, dataCollectedDuringAppraisal, requirements) => {
    const errors = [];

    const requiredDocuments = requirements?.filter(r => r.isRequired(dataCollectedDuringAppraisal));

    requiredDocuments?.forEach(requiredDocument => {
      const schema = getSchema(requiredDocument.validTypes);
      const result = schema.validate(documents, { abortEarly: false });

      if (result.error) {
        errors.push({
          message: `${checkPointDocumentsMap.get(requiredDocument.documentType).Name} is required.`,
          documentType: requiredDocument.documentType
        });
      }
    });

    return errors;
  }
};

const getSchema = validTypes => {
  return Joi.array()
    .items()
    .has(
      Joi.object({
        documentType: Joi.number().valid(...validTypes)
      }).unknown(true)
    );
};

export default CheckpointDocumentsValidator;
